import React from 'react'
import { useTheme } from 'styled-components'
import { Flex, Text, Locked, CheckmarkIcon, TimerIcon } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import useEndOfUTCDayCountdown from 'hooks/useEndOfUTCDayCountdown'
import { StyledButtonLabel } from './styles'

export const NotOnboardedLabel: React.FC = () => {
  const { t } = useTranslation()
  return (
    <StyledButtonLabel type="locked">
      <Flex alignItems="center" gap="6px">
        <Locked width="12px" />
        <Text color="lightBeige" fontSize="11px">
          {t('Onboard to unlock')}
        </Text>
      </Flex>
    </StyledButtonLabel>
  )
}

export const CompletedLabel: React.FC = () => {
  const { t } = useTranslation()
  return (
    <StyledButtonLabel type="success">
      <Flex alignItems="center" gap="6px">
        <CheckmarkIcon fill="black" />
        <Text color="black" fontSize="11px">
          {t('Completed')}
        </Text>
      </Flex>
    </StyledButtonLabel>
  )
}

export const DailyResetLabel: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { refresh } = useGotchiOwner()
  const timeExcerptMap = useEndOfUTCDayCountdown(refresh)

  return (
    <StyledButtonLabel type="locked">
      <Flex alignItems="center" gap="6px">
        <TimerIcon width="14px" fill={theme.colors.lightBeige} />
        <Text color="lightBeige" fontSize="11px">
          {t('Reward resets in %time%', {
            time: timeExcerptMap.h > 0 ? t('%h%hr %m%m', timeExcerptMap) : t('%m%m %s%s', timeExcerptMap),
          })}
        </Text>
      </Flex>
    </StyledButtonLabel>
  )
}
